import { Component, OnInit } from '@angular/core';
import { opinie_polska, opinie_okolice_warszawy, opinie_warszawa } from './opinie.data';


@Component({
  selector: 'enauka-opinie',
  templateUrl: './opinie.component.html',
  styleUrls: ['./opinie.component.css']
})
export class OpinieComponent implements OnInit {
  wszystkie = [];
  polska = [];
  warszawa = [];
  okolice_warszawy = [];

  constructor() { }

  ngOnInit(): void {
    window.scroll(0,0);
    this.polska = opinie_polska;
    this.warszawa = opinie_warszawa;
    this.okolice_warszawy = opinie_okolice_warszawy;
    this.wszystkie = [...this.warszawa, ...this.okolice_warszawy, ...this.polska];
  }

}
